import { SearchCategoryType } from 'model/gloabalSearch.model';
import axios from '../core/axios';
import { ApiConstants } from './api-constants';

type ParamsType = {
  q: string;
  category?: SearchCategoryType;
  limit?: number;
};

export class GlobalSearchService {
  static getSearchResults = async (params: ParamsType) => {
    return await (
      await axios.get(ApiConstants.GLOBAL_SEARCH.GET_GLOBAL_SEARCH_RESULT.URL(), {
        params,
      })
    ).data;
  };
  static postRecentSearch = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.GLOBAL_SEARCH.POST_RECENT_SEARCH.URL(), payload)
    ).data;
  };
  static getRecentSearchResults = async () => {
    return await (
      await axios.get(ApiConstants.GLOBAL_SEARCH.GET_RECENT_SEARCH_RESULTS.URL())
    ).data;
  };
}
